/**
 * Entry Point
 */

import "babel-polyfill";
import "mdn-polyfills/Element.prototype.closest";
import "classlist-polyfill";

import React from 'react';
import ReactDOM from 'react-dom';

// Import Global Styles
import './styles/rlgl.css';

// Import Main Driver
import App from './components/rlgl/App/App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/rlgl.js